// briefDeepLink — pure parser for the morning-brief push deep-link.
//
// The send-morning-brief edge function pushes a url of the form
// `/?brief=<key>&unit=<restaurant_id>` so tapping the notification lands the
// operator on the relevant action surface (reorder / waste) with the brief's
// unit selected. NOTIFY-ONLY: this is navigation, never an execute.
//
// App.jsx parses the search string on boot, switches to the unit (grouped
// operators only), navigates to the surface via navigateTo, then strips the
// params with history.replaceState. This helper isolates the parse/validate
// step so it is unit-testable in isolation.

// Allowed `brief` values must be keys navigateTo(id) understands. Keep this
// in sync with App.jsx navigateTo's map. Any other value is treated as absent
// so an unknown/stale key never throws or mis-navigates — it is simply ignored.
export const BRIEF_NAV_KEYS = [
  'huddle',
  'stock',
  'receive',
  'reorder',
  'stocktake',
  'variance',
  'waste',
  'schedule',
  'roster',
  'catering',
  'labor',
  'insights',
  'marketing',
  'settings',
]

// parseBriefDeepLink(search) → { brief, unit }
//   search — a query string (with or without leading '?'), e.g.
//            '?brief=reorder&unit=abc-123' or window.location.search.
//   brief  — a validated navigateTo key, or null if absent/unknown.
//   unit   — the raw restaurant_id string, or null if absent/empty. The caller
//            still validates it against allUnits before switching (a foreign or
//            stale id must be ignored).
export function parseBriefDeepLink(search) {
  const result = { brief: null, unit: null }
  if (typeof search !== 'string' || search.length === 0) return result

  let params
  try {
    params = new URLSearchParams(search)
  } catch {
    return result
  }

  const brief = params.get('brief')
  if (brief && BRIEF_NAV_KEYS.includes(brief)) {
    result.brief = brief
  }

  const unit = params.get('unit')
  if (unit) {
    result.unit = unit
  }

  return result
}
